var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"create-incident-page-wrapper"},[_c('Header'),_c('section',{staticClass:"sec-create-incident"},[_c('NewIncidentForm',{on:{"navOverview":_vm.navOverview}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }